/**
 *   Descriptor class for security control on a Core Share object. 
 *   LIMITED        = View online only 
 *   VIEWER         = View, download, copy 
 *   COLLABORATOR   = Edit, copy, download, lock, view 
 *   MANAGER        = Full permissions - view, edit, move/copy, delete, add
 *                    collaborators and add/change permissions for collaborators
 *   OWNER          = Owns the file/folder - Do not show this value in the rights 
 *  
 *   CoreRightsValues = {
      "LIMITED"        : 0,
      "VIEWER"         : 1,
      "COLLABORATOR"   : 2,
      "MANAGER"        : 3,
      "OWNER"          : 4
    }
**/

export enum AccessLevelExternal {
  ACCESS_LEVEL_LIMITED = 1,
  ACCESS_LEVEL_VIEWER = 63,
  ACCESS_LEVEL_COLLABORATOR = 255,
  ACCESS_LEVEL_MANAGER = 32255
}

export class SecurityControlExternal {
  private _access: number;

  constructor(access?: number) {
    this._access = (typeof access !== 'undefined') ? access : 0;
  }

  get access(): number {
    return this._access;
  }

  set access(access: number) {
    this._access = access;
  }

  get accessLevel(): number {
    let level: number;

    switch (this._access) {
      case AccessLevelExternal.ACCESS_LEVEL_LIMITED:
      case AccessLevelExternal.ACCESS_LEVEL_VIEWER:
      case AccessLevelExternal.ACCESS_LEVEL_COLLABORATOR:
      case AccessLevelExternal.ACCESS_LEVEL_MANAGER:
        level = this._access; break;
      default:
        level = AccessLevelExternal.ACCESS_LEVEL_VIEWER;
    }
    return level;
  }
}
